import { Button, Tooltip } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { useAuth } from './AuthProvider';

export function LogoutButton() {
  const { isAuthenticated, signoutRedirect } = useAuth();

  if (!isAuthenticated) return null;

  return (
    <Tooltip title="Log out">
      <Button
        color="inherit"
        size="small"
        startIcon={<LogoutIcon />}
        onClick={signoutRedirect}
        sx={{ ml: 2, whiteSpace: 'nowrap' }}
      >
        Log out
      </Button>
    </Tooltip>
  );
}
